// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NerOB7K1wdYYumLOiaB_ {
  position: relative;
  z-index: 301;
  overflow-x: hidden;
  height: 100%;
}

.xIui8A5WJtZZRiobxkpQ {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  gap: 5px;
  margin-bottom: 90px;
}

.x8lMqEHNRGWExhkRWs81 {
  color: #1c77ff;
  font-size: 16.5px;
  font-weight: 540;
  letter-spacing: 0.43px;
  padding: 0;
  background: transparent;
  cursor: pointer;
  border: none;
  transition: background 0.3s ease 0s;
  justify-content: flex-end;
}

.x8lMqEHNRGWExhkRWs81:first-child {
  justify-content: flex-start;
}

.x8lMqEHNRGWExhkRWs81:hover {
  color: #055ada;
  background: transparent;
}

.Ot0JrRbOwOs3urFszcQg {
  color: var(--tg-theme-button-color);
  font-size: 17px;
  font-weight: 760;
  letter-spacing: 0.43px;
  line-height: 129.41%;
  margin: 0 auto;
}

.ctieEIvn4hX1UTnW69zw {
  padding-bottom: 43px;
}

.ctieEIvn4hX1UTnW69zw img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 170px;
  margin: 0 auto 8px auto;
}

.GcWtnLfwdFvKLr5o_PAj {
  color: rgb(var(--placeholder-primary));
  font-weight: 760;
  font-size: 26px;
  text-align: center;
  line-height: 93%;
  letter-spacing: 0.43px;
  margin-bottom: 30px;
  cursor: pointer;
}

.sBGHPeosyAGLolw0VIob {
  color: rgb(var(--placeholder-primary));
  font-size: 16px;
  line-height: 112.5%;
  letter-spacing: 0.7px;
  text-align: center;
  font-weight: 540;
}

.YGfWDbxM1Z53ZXRD05DA {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.W4omtw7xZKLAQpSesR04 {
  margin-top: auto;
  width: 100%;
  font-size: 17px;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/main/buy-modal/pay/pay.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".wrapper {\n  position: relative;\n  z-index: 301;\n  overflow-x: hidden;\n  height: 100%;\n}\n\n.modalTop {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 90px;\n}\n\n.modalTopButton {\n  color: #1c77ff;\n  font-size: 16.5px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  transition: background 0.3s ease 0s;\n  justify-content: flex-end;\n}\n\n.modalTopButton:first-child {\n  justify-content: flex-start;\n}\n\n.modalTopButton:hover {\n  color: #055ada;\n  background: transparent;\n}\n\n.modalTitle {\n  color: var(--tg-theme-button-color);\n  font-size: 17px;\n  font-weight: 760;\n  letter-spacing: 0.43px;\n  line-height: 129.41%;\n  margin: 0 auto;\n}\n\n.modalContent {\n  padding-bottom: 43px;\n}\n\n.modalContent img {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 170px;\n  height: 170px;\n  margin: 0 auto 8px auto;\n}\n\n.modalContentTitle {\n  color: rgb(var(--placeholder-primary));\n  font-weight: 760;\n  font-size: 26px;\n  text-align: center;\n  line-height: 93%;\n  letter-spacing: 0.43px;\n  margin-bottom: 30px;\n  cursor: pointer;\n}\n\n.modalContentText {\n  color: rgb(var(--placeholder-primary));\n  font-size: 16px;\n  line-height: 112.5%;\n  letter-spacing: 0.7px;\n  text-align: center;\n  font-weight: 540;\n}\n\n.modal {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.modalContentBtn {\n  margin-top: auto;\n  width: 100%;\n  font-size: 17px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `NerOB7K1wdYYumLOiaB_`,
	"modalTop": `xIui8A5WJtZZRiobxkpQ`,
	"modalTopButton": `x8lMqEHNRGWExhkRWs81`,
	"modalTitle": `Ot0JrRbOwOs3urFszcQg`,
	"modalContent": `ctieEIvn4hX1UTnW69zw`,
	"modalContentTitle": `GcWtnLfwdFvKLr5o_PAj`,
	"modalContentText": `sBGHPeosyAGLolw0VIob`,
	"modal": `YGfWDbxM1Z53ZXRD05DA`,
	"modalContentBtn": `W4omtw7xZKLAQpSesR04`
};
export default ___CSS_LOADER_EXPORT___;
